import axios from "axios";
import config from "../../config";

import { useState, useEffect } from 'react';

import useAuthenticate from '../authentication/authenticate.js';
import SearchBar from './searchBar.js';
import ProfileDropdown from './profileDropdown.js';

const MobileHeader = ({ toggleSidebar }) => {
    const { user } = useAuthenticate();
    const [propertyRole, setPropertyRole] = useState(null);

    const role = Object.keys(user?.active || {})[0]; // 'manager', 'owner', etc.

    useEffect(() => {
        const fetchPropertyRole = async () => {
            try {
                const res = await axios.get(`${config.API_URL}/v2/role/propertyRole`, {
                    headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
                });
                setPropertyRole(res.data);
            } catch (err) {
                console.error("Failed to fetch property role:", err);
            }
        };

        fetchPropertyRole();
    }, []);

    return (
        <div className="sm:hidden mt-4 mx-[20px] px-5 py-4 bg-[#FCE5CD] flex justify-between items-center rounded-xl">
            <button onClick={toggleSidebar} aria-label="Toggle Sidebar">
                <i className="fa-solid fa-bars text-xl"></i>
            </button>
            <div className="mobile-search">
                <SearchBar />
            </div>
            {propertyRole && propertyRole.length > 0 ? (
                <ProfileDropdown
                    user={user}
                    role={role}
                    account={propertyRole[0]?.account?._id}
                    property={propertyRole[0]?.property?._id}
                />
            ) : (
                <div className="text-gray-500 text-sm">Loading...</div>
            )}
        </div>
    );
};

export default MobileHeader;
